/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/button/css/button';
import './modifier/inline.scss';
import './toast.scss';
